import {
  PasskeyAuthenticationOptionsSchema,
  PasskeyRegistrationOptionsSchema,
  PasskeySchema,
  VerifyScaResponseSchema,
  type PasskeyAssertion,
  type PasskeyRegistrationResponse,
} from '@paguz/contracts';
import { apiRequest } from './client.ts';

/** OTP de SCA en el entorno de demostración (personas sembradas). */
export const DEMO_SCA_CODE = '123456';

const challengePath = (challengeId: string) =>
  `/v1/sca/challenges/${encodeURIComponent(challengeId)}`;

/** `POST /v1/sca/challenges/{id}/verify` → `scaToken` ligado a la operación y al monto (un uso, 5 min). */
export function verifyScaChallenge(challengeId: string, code: string) {
  return apiRequest(`${challengePath(challengeId)}/verify`, VerifyScaResponseSchema, {
    method: 'POST',
    body: { code },
  });
}

/** `POST /v1/sca/challenges/{id}/passkey-options` → opciones WebAuthn para firmar este reto. */
export function getScaPasskeyOptions(challengeId: string) {
  return apiRequest(
    `${challengePath(challengeId)}/passkey-options`,
    PasskeyAuthenticationOptionsSchema,
    { method: 'POST', body: {} },
  );
}

/** Verifica el reto con la aserción de la passkey (huella / Face ID) → el mismo `scaToken` ligado. */
export function verifyScaWithPasskey(challengeId: string, passkeyAssertion: PasskeyAssertion) {
  return apiRequest(`${challengePath(challengeId)}/verify`, VerifyScaResponseSchema, {
    method: 'POST',
    body: { passkeyAssertion },
  });
}

/** Opciones para crear la passkey; exige el reto OTP recién verificado (`scaChallengeId`). */
export function getPasskeyRegistrationOptions(scaChallengeId: string) {
  return apiRequest('/v1/sca/passkeys/registration-options', PasskeyRegistrationOptionsSchema, {
    method: 'POST',
    body: { scaChallengeId },
  });
}

/** `POST /v1/sca/passkeys`: guarda la llave pública de la passkey recién creada. */
export function registerPasskey(input: {
  scaChallengeId: string;
  registration: PasskeyRegistrationResponse;
  deviceLabel?: string;
}) {
  return apiRequest('/v1/sca/passkeys', PasskeySchema, { method: 'POST', body: input });
}

/** Llave de idempotencia (UUID v4 del navegador). */
export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}
